module.exports = __webpack_public_path__ + "img/zkd.3b6050de.jpg";